import { render, staticRenderFns } from "./covid19.vue?vue&type=template&id=b0130458&scoped=true&"
import script from "./covid19.vue?vue&type=script&lang=js&"
export * from "./covid19.vue?vue&type=script&lang=js&"
import style0 from "./covid19.vue?vue&type=style&index=0&id=b0130458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0130458",
  null
  
)

export default component.exports